import axios, { AxiosInstance } from "axios";
import { notification } from "antd";

const axiosMakeInstance: AxiosInstance = axios.create({
  baseURL: "https://hook.us2.make.com",
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosMakeInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

axiosMakeInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      notification.error({
        message: "Erro",
        description: `Erro na requisição: ${error.response.statusText}`,
      });
    } else if (error.request) {
      notification.error({
        message: "Erro de Rede",
        description:
          "Falha ao enviar a requisição. Verifique sua conexão de rede.",
      });
    } else {
      notification.error({
        message: "Erro",
        description: error.message || "Ocorreu um erro.",
      });
    }
    return Promise.reject(error);
  }
);

export default axiosMakeInstance;
